import { jsxs, jsx } from 'react/jsx-runtime';
import 'react';

const LargePlus = ({ testId, className })=>{
    return /*#__PURE__*/ jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        "data-testid": testId,
        className: className,
        children: [
            /*#__PURE__*/ jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M3.2998 12C3.2998 11.6134 3.61321 11.3 3.9998 11.3H19.9998C20.3864 11.3 20.6998 11.6134 20.6998 12C20.6998 12.3866 20.3864 12.7 19.9998 12.7H3.9998C3.61321 12.7 3.2998 12.3866 3.2998 12Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.0002 3.30005C12.3868 3.30005 12.7002 3.61345 12.7002 4.00005L12.7002 20C12.7002 20.3866 12.3868 20.7001 12.0002 20.7001C11.6136 20.7001 11.3002 20.3866 11.3002 20L11.3002 4.00005C11.3002 3.61345 11.6136 3.30005 12.0002 3.30005Z",
                fill: "currentColor"
            })
        ]
    });
};

export { LargePlus as default };
